import { ADMIN_HOME } from '../../utils/HomeNavigation';
import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import LoadingButton from '@mui/lab/LoadingButton';
import AuthContext from '../../context/AuthContext';
import packageJson from '../../../package.json';
import './Login.scss';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.status_code === 200) {
        navigate(ADMIN_HOME);
      } else if (result.error_message === 'invalid_credentials') {
        setError(t('invalid_credentials'));
      } else {
        setError(result.error_message || t('error_during_login') || 'Error durante el inicio de sesión');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Administrador Axium</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="text"
              id="email"
              inputMode="email"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <p style={{ fontSize: 13, color: '#666', margin: '0 0 12px' }}>
            Solo para el personal de Axium. Si sos parte de una empresa, ingresá por portal.axium.uy.
          </p>
          {error && <Alert severity="error" style={{ marginBottom: '16px' }}>{error}</Alert>}
          <LoadingButton type="submit" variant="contained" loading={loading} fullWidth>
            Ingresar
          </LoadingButton>
        </form>
      </div>
      <div className="login-footer">
        <p style={{ marginTop: '8px' }}>Versión: <strong>{packageJson.version}</strong></p>
      </div>
    </div>
  );
};

export default Login;
